import { SPACING } from '@common/theme/spacing'
import { SIZING } from '@common/theme/sizing'
import { Theme } from '@mui/material/styles'

export default function ChipOverrides(theme: Theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: theme.spacing(SPACING.borderRadiusRound),
          height: SIZING.chipMaxHeight,
        },
        deleteIcon: {
          color: '#5D666D',
          '&:hover': {
            color: theme.palette.text.primary,
          },
        },
      },
    },
  }
}
